import { RightOutlined } from '@ant-design/icons';
import Ribbon from 'assets/ribbon.svg?react';
import ModuleCard from 'components/cards/ModuleCard';
import { colors } from 'design';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

const useStyles = createUseStyles({
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  iconContainer: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: colors.gradient.highlight.on,
    fontSize: 20,
  },
  textContainer: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontWeight: 700,
    fontSize: '1rem',
    color: colors.gradient.highlight.on,
    lineHeight: 1.3,
  },
  subtitle: {
    margin: '2px 0 0',
    fontSize: '0.82rem',
    color: colors.gradient.highlight.on,
    lineHeight: 1.3,
  },
  arrow: {
    fontSize: '0.9em',
  },
});

type OctobreRoseCardProps = {
  /** Page the card is displayed on, for analytics and test ids. */
  openedOnPage: 'home' | 'info';
};

export default function OctobreRoseCard({ openedOnPage }: OctobreRoseCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const styles = useStyles();

  const navigateToOctobreRose = () => {
    posthog.capture(`${openedOnPage}.octobre_rose_clicked`);
    navigate(routes.octobreRose.route);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => e.key === 'Enter' && navigateToOctobreRose();

  return (
    <ModuleCard
      style={{ background: colors.gradient.highlight.value }}
      bodyStyle={{ background: 'transparent' }}
      onClick={navigateToOctobreRose}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.content} data-testid={`${openedOnPage}-octobre-rose-card`}>
        <div className={styles.iconContainer}>
          <Ribbon aria-hidden="true" width={32} height={32} />
        </div>
        <div className={styles.textContainer}>
          <p className={styles.title}>{t('home.octobreRose.title')}</p>
          <p className={styles.subtitle}>
            {t('home.octobreRose.subtitle')}
            {/* A non-breaking space, so the caret can't wrap onto a line of its own — it stays glued to the last word. */}{' '}
            <RightOutlined className={styles.arrow} />
          </p>
        </div>
      </div>
    </ModuleCard>
  );
}
